import { Header, Space, Text, Toggle } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useEditApprovalPoolSettingTogglePresenter } from './useEditApprovalPoolSettingTogglePresenter'

export interface IEditApprovalPoolSettingTogglePresenterProps {
  isToggleEnabled: boolean
  isApprovalGroupPooled: boolean
  approvalGroupId: number
  onSettingUpdate?: () => void
  isLoading?: boolean
}

export const EditApprovalPoolSettingTogglePresenter = ({
  isToggleEnabled,
  isApprovalGroupPooled,
  approvalGroupId,
  onSettingUpdate,
  isLoading = false,
}: IEditApprovalPoolSettingTogglePresenterProps) => {
  const intl = useProcurifyIntl()

  const {
    commands: { handleApprovalPoolToggleChange },
  } = useEditApprovalPoolSettingTogglePresenter({
    approvalGroupId,
    onSettingUpdate,
  })

  return !isLoading ? (
    <Space>
      <Space direction='horizontal' align='center' justify='space-between'>
        <Header as='h5'>
          {intl.formatMessage(messages.approvalPoolsHeader)}
        </Header>
        <Toggle
          id='approval-pool-toggle'
          yes={intl.formatMessage(messages.onLabel)}
          no={intl.formatMessage(messages.offLabel)}
          onChange={(_, checked) => handleApprovalPoolToggleChange(checked)}
          checked={isApprovalGroupPooled}
          disabled={!isToggleEnabled}
        />
      </Space>
      <Space.Item>
        <Text>{intl.formatMessage(messages.approvalPoolsDescription)}</Text>
      </Space.Item>
    </Space>
  ) : null
}
